import { getCLS, getFCP, getFID, getLCP, getTTFB, type Metric } from "web-vitals";
import posthog from "posthog-js";

/**
 * Report Core Web Vitals into PostHog (the dep was installed but nothing
 * imported it, so it collected nothing). Uses the web-vitals v2 API
 * (getCLS/getFID/getFCP/getLCP/getTTFB) matching the installed ^2.1.4.
 *
 * Metrics land as `$web_vitals` events so they can be charted in PostHog
 * alongside the rest of the web analytics. Wrapped in try/catch so a metrics
 * failure can never affect the app.
 */
export function reportWebVitals(): void {
  const send = (metric: Metric): void => {
    try {
      posthog.capture("$web_vitals", {
        metric_name: metric.name,
        metric_value: metric.value,
        metric_delta: metric.delta,
        metric_id: metric.id,
      });
    } catch {
      /* analytics must never break the app */
    }
  };

  getCLS(send);
  getFID(send);
  getFCP(send);
  getLCP(send);
  getTTFB(send);
}
